import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext({});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("koptur_token");
    if (!token) {
      setReady(true);
      return;
    }
    api
      .me()
      .then((u) => setUser(u))
      .catch(() => localStorage.removeItem("koptur_token"))
      .finally(() => setReady(true));
  }, []);

  const login = useCallback(async (username, password) => {
    const res = await api.login(username, password);
    localStorage.setItem("koptur_token", res.token);
    setUser({ username: res.username });
    return res;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("koptur_token");
    setUser(null);
  }, []);

  return (
    <AuthCtx.Provider value={{ user, ready, login, logout }}>{children}</AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
